import React, { useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { request } from "utils/proxy";
import Pager from "components/Pager";
import IconButton from "@cayuse/shared-react.components.icon-button";
import StudyTable from "./StudyTable";
import PagingControls from "@cayuse/shared-react.components.paging-controls";
import Study from "./Study";
import Button from "@cayuse/shared-react.components.button";
import Modal from "@cayuse/shared-react.components.modal";

import styles from "./StudySearch.css";


const StudySearch = ({ addStudies, dictionary }) => {
	const [ open, setOpen ] = useState(false);
	const [ selectedStudies, setSelectedStudies ] = useState([]);
	const [ availableStudies, setAvailableStudies ] = useState([]);
	const [ studiesToShow, setStudiesToShow ] = useState([]);
	const [ itemsPerPage, setItemsPerPage ] = useState(5);
	const [ pageNumber, setPageNumber ] = useState(0);
	const [ numberOfPages, setNumberOfPages ] = useState(0);

	const saveStudies = () => {
		addStudies(selectedStudies);
		setSelectedStudies([]);
		setAvailableStudies([]);
		setStudiesToShow([]);
		setOpen(false);
	};

	const addStudyToSelectedRecords = study => {
		let selected = [ ...selectedStudies ];
		selected.push(study);
		setSelectedStudies(selected);
	};

	const cancelSelectedStudy = index => {
		let selected = [ ...selectedStudies ];
		selected.splice(index, 1);
		setSelectedStudies(selected);
	};

	const studySearch = searchInput => {
		let searchText = searchInput.target.value;
		request(`/sp/api/studies?proposalId=${searchText}`) // todo: convert to path constant
			.then(availableStudies => {
				setAvailableStudies(availableStudies);
				updatePageSize(itemsPerPage);
			});
	};

	const loadNextPage = nextPageNumber => {
		nextPageNumber--;
		const studiesToShow = Pager.pageSlice(availableStudies, itemsPerPage, nextPageNumber);
		setStudiesToShow(studiesToShow);
		setPageNumber(nextPageNumber);
	};

	const updatePageSize = itemsPerPage => {
		const numberOfPages = Math.ceil(availableStudies / itemsPerPage);
		const studiesToShow = Pager.pageSlice(availableStudies, itemsPerPage, 0);
		setItemsPerPage(itemsPerPage);
		setNumberOfPages(numberOfPages);
		setStudiesToShow(studiesToShow);
	};

	return (
		<Modal
			size="two-thirds"
			closeIcon
			trigger={(
				<IconButton icon="search" onClick={() => setOpen(true)} labelPosition="left">
					{dictionary?.findIrbStudy || "Find IRB Study"}
				</IconButton>
			)}
			open={open}
			onClose={() => setOpen(false)}
			ariaLabel={dictionary?.studyFinder || "Study Finder"}
		>
			<div className="ui left icon input">
				<input type="text" placeholder="Click to search..."
					onKeyUp={input => studySearch(input)}
				/>
				<i aria-hidden="true" className="search icon"/>
			</div>
			<Modal.Header className="ui header whiteOnBlue">
				<h2>{dictionary?.studyFinder || "Study Finder"}</h2>
			</Modal.Header>
			<Modal.Content className={styles.content}>
				<StudyTable studiesToShow={studiesToShow}
					onAdd={study => addStudyToSelectedRecords(study)}
				/>
				<PagingControls items={studiesToShow}
					onPageChange={page => loadNextPage(page)}
					totalItems={availableStudies.length}
					pageLimit={itemsPerPage}
					pageOffset={pageNumber}
					totalPages={numberOfPages}
					onPageSizeChange={itemsPerPage => updatePageSize(itemsPerPage)}
					showPageSizeControl={false}
				/>
				{selectedStudies.length > 0 ? (<div className={`ui cards ${styles.cardMargin}`}>
					{selectedStudies.map(
						(study, index) => {
							return (
								<Study key={`study-${index}`} study={study} close={() => cancelSelectedStudy(index)}/>);
						})}
				</div>) : ""}
			</Modal.Content>
			<Modal.Actions>
				<Button secondary onClick={() => setOpen(false)}>Cancel</Button>
				<Button onClick={() => saveStudies()}>Save</Button>
			</Modal.Actions>
		</Modal>
	);
};

StudySearch.propTypes = {
	addStudies: PropTypes.func
};

const mapStateToProps = state => ({
	dictionary: state.dictionary.irbStudy
});

export default connect(mapStateToProps)(StudySearch);
